import PropTypes from 'prop-types';
import { Small } from 'foundations-components/transitional/components/Small';
import TimelineMonthLabel from '../generic/TimelineMonthLabel';
import { View } from 'foundations-components/transitional/components/View';

// @ts-expect-error ts-migrate(2339) FIXME: Property 'defaultProps' does not exist on type 'ty... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function TimelineMonth({
  text,
  label,
  isFirstMonth = false,
  isVirtualized = false
}) {
  return /*#__PURE__*/_jsxs(View, {
    paddingInline: "400",
    paddingBlock: isVirtualized ? '400' : undefined,
    "data-test-id": "timeline-month-label-container",
    children: [/*#__PURE__*/_jsx(TimelineMonthLabel, {
      marginBlockStart: isFirstMonth ? undefined : '0',
      children: label
    }), text && /*#__PURE__*/_jsx(Small, {
      marginBlockStart: "200",
      children: text
    })]
  });
}
TimelineMonth.displayName = 'TimelineMonth';
TimelineMonth.propTypes = {
  isFirstMonth: PropTypes.bool,
  isVirtualized: PropTypes.bool,
  label: PropTypes.string,
  text: PropTypes.string
};
export default TimelineMonth;